module.exports = __webpack_public_path__ + "img/campaign-pilot-ellipse.81ad87ff.png";